import { CustomError } from 'ts-custom-error'
import { type GraphQLFormattedError } from 'graphql'

class GraphQLAggregateError extends CustomError {
  errors: ReadonlyArray<GraphQLFormattedError>

  constructor(errors: ReadonlyArray<GraphQLFormattedError>) {
    super(errors.map(({ message }) => message).join('\n'))
    this.errors = errors
  }
}

export default GraphQLAggregateError
